export default {
    dev: {
        serverUrl: '/jdeco-oa', // 测试接口域名
        weatherUrl: '/caiyun',
        tdtUrl: '/tdt',
        aliagent: '/aliagent'
    },
    test: {
        serverUrl: '/jdeco-oa', // 测试接口域名
        weatherUrl: '/caiyun',
        tdtUrl: '/tdt',
        aliagent: '/aliagent'
    },
    pred: {
        serverUrl: '/jdeco-oa', // 测试接口域名
        weatherUrl: '/caiyun',
        tdtUrl: '/tdt',
        aliagent: '/aliagent'
    },
    prod: {
        serverUrl: '/jdeco-oa', // 测试接口域名
        weatherUrl: '/caiyun',
        tdtUrl: '/tdt',
        aliagent: '/aliagent'
    }
}
